import './ScreenSizeGuard.scss';
import { constUndefined } from 'fp-ts/lib/function';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'src/modules/common/components/Modal';
import { ModalBody } from 'src/modules/common/components/ModalBody';

type Props = {
  children: React.ReactNode;
};

export const ScreenSizeGuard = memo(({ children }: Props) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const screenWidthChangeListener = useCallback(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', screenWidthChangeListener);

    window.screen.orientation.addEventListener('change', screenWidthChangeListener);

    return (): void => {
      window.removeEventListener('resize', screenWidthChangeListener);

      window.screen.orientation.removeEventListener('change', screenWidthChangeListener);
    };
  }, [screenWidthChangeListener]);

  return screenWidth >= supportedScreenWidth
    ? children
    : (
      <div className="bp-screen-size-guard">
        <Modal
          opened={true}
          handleClose={constUndefined}
          shouldCloseOnOverlayClick={false}
        >
          <ModalBody>
            <h2 className="bp-screen-size-guard__modal-label">
              <FormattedMessage id="screenSizeGuard/modal/label"/>
            </h2>

            <h1 className="bp-screen-size-guard__modal-title">
              <FormattedMessage id="screenSizeGuard/modal/title"/>
            </h1>

            <p className="bp-screen-size-guard__modal-description">
              <FormattedMessage id="screenSizeGuard/modal/description"/>
            </p>

            <p className="bp-screen-size-guard__modal-description">
              <FormattedMessage id="screenSizeGuard/modal/hint"/>
            </p>
          </ModalBody>
        </Modal>
      </div>
    );
});

const supportedScreenWidth = 1024;
